module.exports = __webpack_public_path__ + "img/logo.d0b9a6cf.png";